import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GridComponent } from '@progress/kendo-angular-grid';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';

@Component({
    selector: 'app-account-box-mapping-list',
    templateUrl: './account-box-mapping-list.component.html',
    styleUrls: ['./account-box-mapping-list.component.scss']
})
export class AccountBoxMappingListComponent extends AppComponentBase implements OnInit {

    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @Output() emitBoxMappingEmit: EventEmitter<any> = new EventEmitter<any>();

    @Input() set accountId(accountId: any) {
        if (accountId) {
            this.accId = accountId;
            this.getBoxMappingList(accountId);
        }
    }

    accId: any;

    public boxCount = 0;
    gridItems: any = {
        data: [],
        total: 0
    };
    isFormLoading = false;

    constructor(
        injector: Injector,
        private commonService: CommonService,
        private toastr: ToastrService,
    ) {
        super(injector);
    }

    ngOnInit() {
    }

    getBoxMappingList(accountId: any) {
        this.kendogridHelper.showLoadingIndicator();
        const query = `AccountId=${accountId}&IsActive=true`;
        this.commonService.getAccountBoxMappingRecords(query)
            .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe(response => {
                if (response.isSuccess) {
                    this.gridItems = {
                        data: response.data,
                        total: response.data.length
                    };
                    this.boxCount = response.data.length;
                    this.emitBoxMappingEmit.emit(response.data.length);
                } else {
                    this.toastr.error(response.errors, 'Error!');
                }

            });
    }

}
